import { FC } from 'react'

import { ResourceHeader } from '@factorialco/f0-react/dist/experimental'
import DOMPurify from 'dompurify'
import {
  MyTrainingFormHeaderFragment,
  MyTrainingFormMembershipFragment,
} from 'generated/resources/graphql'

import { buildUrl } from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

type Props = {
  form: MyTrainingFormHeaderFragment | undefined
  answers: boolean
  trainingName: string
  target: MyTrainingFormMembershipFragment | undefined | null
  score?: number
}

export const MyTrainingFormHeader: FC<Props> = ({ target, trainingName, answers, form, score }) => {
  const formType = form?.form?.formType

  return (
    <ResourceHeader
      title={form?.form?.title ?? ''}
      metadata={[
        {
          label: i18n.t('trainings.my_trainings_revamp.surveys.header.title'),
          value: {
            type: 'text',
            content: trainingName,
          },
        },
        formType !== 'satisfaction' && {
          label: i18n.t('trainings.my_trainings_revamp.surveys.header.participant'),
          value: {
            type: 'avatar',
            text: target?.target?.fullName ?? '',
            variant: {
              type: 'person',
              src: buildUrl(target?.target?.avatar) ?? '',
              firstName: target?.target?.firstName ?? '',
              lastName: target?.target?.lastName ?? '',
            },
          },
        },
        score !== undefined && {
          label: i18n.t('trainings.my_trainings_revamp.surveys.header.score'),
          value: {
            type: 'text',
            content: `${score}%`,
          },
        },
      ]}
      description={DOMPurify.sanitize(form?.form?.description ?? '', { ALLOWED_TAGS: [] })}
      status={{
        label: '',
        text: answers
          ? i18n.t('trainings.my_trainings_revamp.surveys.header.status.completed')
          : i18n.t('trainings.my_trainings_revamp.surveys.header.status.pending'),
        variant: answers ? 'positive' : 'warning',
      }}
    />
  )
}
